/**
 * Automation Actions
 * Handlers for automation-related actions (e.g., configure automated tasks)
 */

import type { DetailActionContext, BaseEntity } from "../types/detailPage";
import type { UniversalActionHandlers } from "./types";
import { MODAL_IDS } from "@west-tennessee-consulting/ui";

/**
 * Configure automated tasks action handler
 * Opens the ConfigureAutomatedTasksModal with entity context
 */
const configureAutomatedTasks = async (item: BaseEntity, context: DetailActionContext<BaseEntity>) => {
  // Get entity type from page config (e.g., "deals", "contacts", "companies")
  const entityType = context.pageConfig?.entityName || "unknown";
  const entityId = item.id;
  const entityName = item.name || item.title || "Unknown";

  // Open the automation modal with entity context using the context method
  context.onOpenModal(MODAL_IDS.automation.configureAutomatedTasks, {
    entityType,
    entityId,
    entityName,
  });
};

/**
 * Export all automation action handlers
 */
export const automationActions: UniversalActionHandlers = {
  configureAutomatedTasks,
};

